var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {
    'inside-status-bar': true
  }, _obj[_vm.currentWrapperClass] = true, _obj )},[_c('div',{staticClass:"status-bar-icon"},[_c('img',{attrs:{"src":_vm.currentIcon}})]),_c('div',{staticClass:"status-bar-info"},[_c('h2',{staticClass:"order-number"},[_vm._v(_vm._s(_vm.$t("card.order"))+" "+_vm._s(_vm.index + 1))]),_c('span',{staticClass:"status-description"},[_vm._v(_vm._s(_vm.statusDescription))])])])}
var staticRenderFns = []

export { render, staticRenderFns }